import { Controller } from '@hotwired/stimulus';

// Points the hub search form directly at the selected vertical's index path so
// submits (incl. places-autocomplete's form.submit()) skip the 301 canonical
// redirect. Without JS the form falls back to /pflegedienste?provider_type=X.
export default class extends Controller {
  static targets = ['form'];

  connect() {
    this.update();
  }

  update() {
    const checked = this.element.querySelector("input[name='provider_type']:checked");
    if (checked?.dataset.path) this.formTarget.action = checked.dataset.path;
  }
}
